/**
 * Zod schemas for field-level data-point permissions (Issue #1560).
 *
 * Validates input from the per-tenant field-permission editor before the
 * value reaches 29-case-mgmt. Mirrors `UpdateFieldPermissionsInput` and
 * its `FieldStageOverride` substructure from the DTO module.
 *
 * @see ./../dtos/field-permission.dto
 */

import { z } from 'zod';
import { UserRole } from '../enums/roles';

const userRoleEnum = z.nativeEnum(UserRole);

/**
 * Schema for the per-stage refinement object. Both arrays are optional;
 * fields omitted in a stage override fall back to the field's top-level
 * `viewableByRoles` / `editableByRoles`.
 */
export const fieldStageOverrideSchema = z.object({
  viewableByRoles: z.array(userRoleEnum).optional(),
  editableByRoles: z.array(userRoleEnum).optional(),
});

/**
 * Schema for `UpdateFieldPermissionsInput` — patch the role attribution
 * for a single field. The service layer auto-forks an un-forked template
 * before applying.
 */
export const updateFieldPermissionsInputSchema = z.object({
  businessId: z.string().uuid(),
  canonicalKey: z.string().min(1),
  viewableByRoles: z.array(userRoleEnum).default([]),
  editableByRoles: z.array(userRoleEnum).default([]),
  hiddenForRoles: z.array(userRoleEnum).default([]),
  roleVisibilityByStage: z.record(z.string(), fieldStageOverrideSchema).optional(),
  reason: z.string().max(2000).optional(),
});
